import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { setSlideKey, setBubbleSeenByUser, setPercentageButtonRef } from 'store/onboarding';

import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';

import { LIST_SLIDE_KEY } from 'components/onboarding/constants';

import { Theme } from 'styles/ThemeTyping';

interface Props {
  onOnboardingButtonClick: (_buttonName: string) => void;
}

function OnboardingListButton({ onOnboardingButtonClick }: Props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const percentageButtonRef = useRef(null);

  const onboardingState = useSelector((state: any) => state.onboarding);

  const { bubbleSeenByUser, bubbleOpen, buttonName, overallCompletion } = onboardingState;

  const completionPercentage = Math.round(overallCompletion * 100);

  const handleToggleBubbleOpenOnPercentage = () => {
    !bubbleSeenByUser && dispatch(setBubbleSeenByUser());
    dispatch(setSlideKey(LIST_SLIDE_KEY));
    onOnboardingButtonClick('percentage');
  };

  useEffect(() => {
    dispatch(setPercentageButtonRef(percentageButtonRef));
  }, []);

  return (
    <Fab
      onClick={handleToggleBubbleOpenOnPercentage}
      className={classNames(
        classes.listButton,
        bubbleOpen && buttonName === 'percentage' && classes.activeButton,
      )}
      disableRipple
      ref={percentageButtonRef}
      data-cy="percentage-button"
    >
      <Typography className={classes.completionPercentage} variant="caption">
        {completionPercentage}%
      </Typography>
      <CircularProgress
        value={completionPercentage}
        variant="static"
        className={classes.completion}
      />
    </Fab>
  );
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    completion: {
      color: theme.palette.success.main,
    },
    completionPercentage: {
      position: 'absolute',
    },
    listButton: {
      backgroundColor: theme.palette.common.white,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[5],
      },
    },
    activeButton: {
      boxShadow: theme.shadows[5],
    },
  };
});

export default OnboardingListButton;
